import { SchoolContentDictionary } from './types';

export const classRoomImage: SchoolContentDictionary = {
	en: '/_n/images/schools/30-days-mindfulness-classroom.webp',
	fr: '/_n/images/schools/Mockup_30_days_of_mindfulness_FR_1.webp',
	es: '/_n/images/schools/Mockup_30_days_of_mindfulness_MX.webp',
	de: '/_n/images/schools/Mockup_30_days_of_mindfulness_DE.webp',
	pt: '/_n/images/schools/Mockup_30_days_of_mindfulness_BR.webp',
};

export const selfCareImage: SchoolContentDictionary = {
	en: '/_n/images/schools/self-care-guide.webp',
	fr: '/_n/images/schools/Mockup_Self_Care_FR.webp',
	es: '/_n/images/schools/Mockup_Self_Care_MX.webp',
	de: '/_n/images/schools/Mockup_Self_Care_DE.webp',
	pt: '/_n/images/schools/Mockup_Self_Care_BR.webp',
};

export const classRoomUrl: SchoolContentDictionary = {
	en: 'https://cal.mn/30Days',
	fr: 'https://assets.calm.com/b7e1e46d9e15db5964f279a0a588a226.pdf',
	es: '/_n/pdf/schools/teacher_resource_guide_es-final.pdf',
	de: 'https://assets.calm.com/204818cf7de01c54e31b123a55625173.pdf',
	pt: 'https://assets.calm.com/c17c6247a2f721d736584a392fecd49c.pdf',
};

export const selfCareUrl: SchoolContentDictionary = {
	en: 'https://cal.mn/teachers',
	fr: 'https://assets.calm.com/adff6baff6b6dc3e1917edffd1f9f57a.pdf',
	es: 'https://assets.calm.com/aa3119c7513b63045bf15f71e25b5aa0.pdf',
	de: 'https://assets.calm.com/ae728f18513953b90f48f50fc1484e86.pdf',
	pt: 'https://assets.calm.com/6ceae648330c8204d9df5947a5f6d56b.pdf',
};
